import * as React from "react";
import * as _ from "lodash";
import { DataGridContent } from "../../../Models";
import { DataGridReusable } from "./TableReusable";

type IDataGridProps = {
    content: DataGridContent;
    showPagination: boolean;
    isSortable: boolean;
    filterable: boolean;
    defaultPageSize?: number;
    hideHeader?: boolean;
};

export default function DataGrid(props: IDataGridProps) {
    const { defaultPageSize, content, isSortable, showPagination } = props;

    const { columns, data } = content;

    return (
        <DataGridReusable
            filterable={props.filterable}
            defaultPageSize={defaultPageSize ? defaultPageSize : 150000}
            data={data}
            columns={columns}
            showPagination={showPagination}
            isSortable={isSortable}
            hideHeader={props.hideHeader}
        />
    );
}
